export enum BillingMethodsEnum {
  NO_BILLING_METHOD_SELECTED = 'NO_BILLING_METHOD_SELECTED',
  PROJECT_HOURLY_RATE = 'PROJECT_HOURLY_RATE',
  PERSON_HOURLY_RATE = 'PERSON_HOURLY_RATE',
  TASK_HOURLY_RATE = 'TASK_HOURLY_RATE',
}
